import { useEffect, useState } from "react";
import { Carousel } from "primereact/carousel";
import { Skeleton } from "primereact/skeleton";
import { TabPanel, TabView } from "primereact/tabview";
import { PathCard } from "sj-ui-toolkit/src/atlas/components/ContentCard/PathCard/PathCard";
import { C, themeClasses as T } from "sj-ui-toolkit/src/atlas/utils";

import carouselStyles from "../CarouselOverrides.module.scss";

export const MyPaths = ({ currentPaths = [], currentQuests = [], isLoading = false }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => setActiveIndex(currentPaths.length > 0 ? 0 : 1), [currentPaths.length]);

  if (isLoading) {
    return (
      <div className={carouselStyles.carouselContainer}>
        <TabView
          aria-label="My active enrollments"
          className={carouselStyles.carouselSection}
          pt={{
            navContainer: { className: C("sticky top-0 z-2", T.bgElevation0) },
            nav: { className: C("atlas-h5", carouselStyles.sectionHeader) },
            panelContainer: { className: C("p-0 px-10", T.bgElevation0) },
          }}
        >
          <TabPanel header={<Skeleton width="150px" height="24px" />}>
            <Skeleton width="100%" height="500px" borderRadius="8px" />
          </TabPanel>
        </TabView>
      </div>
    );
  }

  if (!currentPaths?.length && !currentQuests?.length) {
    return null;
  }

  return (
    <div className={carouselStyles.carouselContainer}>
      <TabView
        aria-label="My active enrollments"
        className={carouselStyles.carouselSection}
        activeIndex={activeIndex}
        onTabChange={e => setActiveIndex(e.index)}
        pt={{
          navContainer: { className: C("sticky top-0 z-2", T.bgElevation0) },
          nav: { className: C("atlas-h5", carouselStyles.sectionHeader) },
          panelContainer: { className: C("p-0", T.bgElevation0) },
        }}
      >
        {currentPaths.length > 0 && (
          <TabPanel header="My Paths">
            <Carousel
              aria-label="My Paths"
              className={C(
                carouselStyles.customCarousel,
                currentPaths.length <= 1 && carouselStyles.singlePageCarousel
              )}
              value={currentPaths}
              numVisible={1}
              numScroll={1}
              showIndicators={currentPaths.length > 1}
              showNavigators={currentPaths.length > 1}
              itemTemplate={(path, index) => (
                <PathCard key={index} {...path} cardSize="large" status="inProgress" />
              )}
            />
          </TabPanel>
        )}
        {currentQuests.length > 0 && (
          <TabPanel header="My Quests">
            <Carousel
              aria-label="My Quests"
              className={C(
                carouselStyles.customCarousel,
                currentQuests.length <= 1 && carouselStyles.singlePageCarousel
              )}
              value={currentQuests}
              numVisible={1}
              numScroll={1}
              showIndicators={currentQuests.length > 1}
              showNavigators={currentQuests.length > 1}
              itemTemplate={(path, index) => (
                <PathCard
                  key={index}
                  {...path}
                  cardSize="large"
                  pathType="Quest"
                  status="inProgress"
                />
              )}
            />
          </TabPanel>
        )}
      </TabView>
    </div>
  );
};
